export default __webpack_public_path__ + "static/media/blackFront1.3948ad6d.png";